export const cardDetails = {
    BANK_CARD: {
        AUTHORIZED_STANDALONE: {
            fields: ['owner', 'insuranceType', 'insuranceInsured', 'validDates'],
        },
        MAIN: { fields: ['owner', 'insuranceType', 'insuranceInsured', 'validDates'] },
    },
    CREDIT: {
        AUTHORIZED_STANDALONE: {
            fields: [
                ['outstandingAmount', 'balance', 'limit'],
                ['owner', 'validDates'],
            ],
        },
        MAIN: {
            fields: [
                ['outstandingAmount', 'balance', 'limit'],
                ['owner', 'validDates', 'contactless'],
            ],
        },
    },
};
